import toast from "react-hot-toast";
import {
  getMe,
  setLoadingUpdateUserPass,
  setLoadingUpdateUser,
  setUserScore,
  setUserLevel,
  setMaxScore,
  setMinScore,
  setCheckUserInfo,
  setShowRegister,
  setShowOtp,
  setLoadingRegister,
  setSuggestedUserData,
  setUserPoint,
} from "../../redux/actions/User";
import appApi from "../../utils/AppApi";
import erorhandler from "../../utils/ErrorHandler";

const UsersRequests = {
  requesteOtp: (user, resend) => {
    return (dispatch) => {
      dispatch(setLoadingRegister(true));
      try {
        appApi
          .post("/user/otprequestV2", {
            nationalCode: user.nationalCode,
            phone: user.phone,
            resend: resend,
          })
          .then(() => {
            dispatch(setLoadingRegister(false));
            dispatch(setShowOtp(true));
          })
          .catch((error) => {
            dispatch(setLoadingRegister(false));
            console.log(error);
          });
      } catch (error) {
        dispatch(setLoadingRegister(false));
        console.log(error);
      }
    };
  },
  checkUserExists: (userData) => {
    return async (dispatch) => {
      dispatch(setLoadingRegister(true));
      const { captchaId, captchaAnswer, ...userInfo } = userData;
      dispatch(setCheckUserInfo(userInfo));
      try {
        const { data } = await appApi.post("/user/userexists", userData);
        if (data.user) {
          dispatch(UsersRequests.requesteOtp(data.user, false));
        } else {
          dispatch(setLoadingRegister(false));
          dispatch(setShowRegister(true));
          dispatch(setSuggestedUserData(data.suggestedUserData));
        }
        return true;
      } catch (error) {
        dispatch(setLoadingRegister(false));
        erorhandler(error);
        return false;
      }
    };
  },
  registerUser: (userData) => {
    return (dispatch) => {
      dispatch(setLoadingRegister(true));
      try {
        appApi
          .post("/user/registerV2", userData)
          .then(() => {
            dispatch(setLoadingRegister(false));
            dispatch(setShowOtp(true));
          })
          .catch((error) => {
            erorhandler(error);
            dispatch(setLoadingRegister(false));
          });
      } catch (error) {
        erorhandler(error);
        dispatch(setLoadingRegister(false));
      }
    };
  },
  getme: () => {
    return (dispatch) => {
      try {
        appApi
          .get("/user/getme")
          .then(({ data }) => {
            dispatch(getMe(data.user));
          })
          .catch((error) => {
            return;
          });
      } catch (error) {
        return;
      }
    };
  },
  updatePassWord: (userid, passWords) => {
    return (dispatch) => {
      dispatch(setLoadingUpdateUserPass(true));
      try {
        appApi
          .patch(`/user/update/password/${userid}`, {
            oldPassword: passWords.old,
            newPassword: passWords.new,
          })
          .then(() => {
            dispatch(setLoadingUpdateUserPass(false));
            toast.success("رمز عبور شما با موفقیت به روز رسانی شد");
          })
          .catch((error) => {
            erorhandler(error);
          });
      } catch (error) {
        dispatch(setLoadingUpdateUserPass(false));
        erorhandler(error);
      }
    };
  },
  getUserScore: () => {
    return async (dispatch) => {
      try {
        await appApi.get(`/score/user/getmyscore`).then(({ data }) => {
          dispatch(setUserScore(data.totalScore));
          dispatch(setUserLevel(data.level));
          dispatch(setMaxScore(data.maxScore));
          dispatch(setMinScore(data.minScore));
        });
      } catch (error) {
        return;
      }
    };
  },
  getUserPoint: () => {
    return async (dispatch) => {
      try {
        await appApi.get(`/pointbank/getme`).then(({ data }) => {
          dispatch(setUserPoint(data.point));
        });
      } catch (error) {
        return;
      }
    };
  },
  updateUser: (userid, userInfo) => {
    return (dispatch) => {
      dispatch(setLoadingUpdateUser(true));
      try {
        appApi
          .patch(`/user/update/${userid}`, {
            profileImage: userInfo.profileImage,
          })
          .then(({ data }) => {
            toast.success("اطلاعات کاربری شما با موفقیت به روز رسانی شد");
            dispatch(getMe(data.user));
            dispatch(setLoadingUpdateUser(false));
          })
          .catch((error) => {
            erorhandler(error);
            dispatch(setLoadingUpdateUser(false));
          });
      } catch (error) {
        erorhandler(error);
        dispatch(setLoadingUpdateUser(false));
      }
    };
  },
  updateUserInfo: (userid, userInfo) => {
    return (dispatch) => {
      dispatch(setLoadingUpdateUser(true));
      try {
        appApi
          .patch(`/user/update/${userid}`, userInfo)
          .then(({ data }) => {
            toast.success("اطلاعات کاربری شما با موفقیت به روز رسانی شد");
            dispatch(getMe(data.user));
            dispatch(setLoadingUpdateUser(false));
          })
          .catch((error) => {
            erorhandler(error);
            dispatch(setLoadingUpdateUser(false));
          });
      } catch (error) {
        erorhandler(error);
        dispatch(setLoadingUpdateUser(false));
      }
    };
  },
};

export default UsersRequests;
